export default "__VITE_ASSET__122c7dc7__"